import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportViewer } from '../model/report-viewer';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  constructor(private http: HttpClient, private dataService: DataService) { }

  private readonly createEndPoint: string = '/prescription/create/';
  private readonly deleteEndPoint: string = '/prescription/delete/';
  private readonly getPrescriptionReportPdfEndPoint: string = '/prescription/getPrescriptionReportPdf/';
  private readonly getPrescriptionReportPdfByIdEndPoint: string = '/prescription/getPrescriptionReportPdfById/';
  private readonly getPrescriptionReportsBase64ByMedicalAppointmentIdEndPoint: string = '/prescription/getPrescriptionReportsBase64ByMedicalAppointmentId/';

  async create(
    medicalAppointmentId: number,
    prescription: string): Promise<number> {
    const params = { MedicalAppointmentId: medicalAppointmentId, Prescription: prescription };
    return await this.dataService.post<number>
      (this.createEndPoint, params).toPromise();
  }

  async delete(
    id: number): Promise<boolean> {
    const params = { Id: id };
    return await this.dataService.post<boolean>
      (this.deleteEndPoint, params).toPromise();
  }

  async getPrescriptionReportPdf(
    medicalAppointmentId: number,
    prescriptionText: string): Promise<ReportViewer> {
    const params = { medicalAppointmentId, prescriptionText };
    return await this.dataService.get<ReportViewer>
      (this.getPrescriptionReportPdfEndPoint, params).toPromise();
  }

  async getPrescriptionReportPdfById(
    id: number): Promise<ReportViewer> {
    const params = { id };
    return await this.dataService.get<ReportViewer>
      (this.getPrescriptionReportPdfByIdEndPoint, params).toPromise();
  }

  async getPrescriptionReportsBase64ByMedicalAppointmentId(
    medicalAppointmentId: number): Promise<ReportViewer[]> {
    const params = { medicalAppointmentId };
    return await this.dataService.get<ReportViewer[]>
      (this.getPrescriptionReportsBase64ByMedicalAppointmentIdEndPoint, params).toPromise();
  }

}
